import strings from 'strings'

export const MAX_IMAGE_BYTES = 1024 * 1024

export const ALLOWED_IMAGE_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'image/x-icon',
  'image/vnd.microsoft.icon',
  'image/avif',
]

export const ALLOWED_IMAGE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.ico',
  '.avif',
]

export const IMAGE_ACCEPT = [
  ...ALLOWED_IMAGE_EXTENSIONS,
  ...ALLOWED_IMAGE_MIME_TYPES,
].join(',')

export const validateImageFile = (file: File): string | null => {
  const name = file.name.toLowerCase()
  const hasAllowedExtension = ALLOWED_IMAGE_EXTENSIONS.some((ext) =>
    name.endsWith(ext)
  )
  const hasAllowedType =
    !file.type || ALLOWED_IMAGE_MIME_TYPES.includes(file.type)
  if (!hasAllowedExtension || !hasAllowedType) {
    return strings.WHITE_LABEL.INVALID_IMAGE_TYPE
  }
  if (file.size > MAX_IMAGE_BYTES) return strings.WHITE_LABEL.IMAGE_TOO_LARGE
  return null
}
